export default __webpack_public_path__ + "static/media/join-bg.ddb25565.mp4";